import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {
    CardDto, CardService, SearchCustomerDto
} from '../../../../_services/configuration-services';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Observable, of} from 'rxjs';
import {catchError, debounceTime, distinctUntilChanged, switchMap, tap} from 'rxjs/operators';
import {NotificationsService} from '../../../../_shared/notifications.service';
import {FormUtils} from '../../../../_shared/form-utils';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-customer-rfid-card-modal',
    templateUrl: './customer-rfid-card-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CustomerRfidCardModalComponent implements OnInit {

    @Input() customerId: string | null = null;
    @Input() rfidCards: CardDto[] = [];

    rfidCard: CardDto;

    alreadyAssigned = false;
    selfAssigned = false;
    textInputPattern = FormUtils.textInputPattern;

    // SearchCard
    searchFailed = false;
    rfidCardResult: CardDto;

    formatter = (result: CardDto) => this.printFormattedCardIdentifier(result);

    constructor(public activeModal: NgbActiveModal,
                private readonly rfidCardService: CardService,
                private readonly notificationsService: NotificationsService,
                private readonly translateService: TranslateService) {

    }

    ngOnInit(): void {
        this.rfidCard = new CardDto();
    }

    searchRfidCards = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(300),
            distinctUntilChanged(),
            switchMap(term => {
                if (term.length < 1) {
                    this.clearInput();
                    return of([]);
                }
                term = term.replace('N°', '').replace(' - ', '').replace('UID', '');
                return this.rfidCardService.searchUnassignedRfidCards(term).pipe(
                    tap(res => {
                        if (res == null || res.length === 0) {
                            this.searchFailed = true;
                            return of([]);

                        } else {
                            this.searchFailed = false;
                            return of([]);
                        }
                    }),
                    catchError(() => {
                        this.searchFailed = true;
                        return of([]);
                    }));
            }))

    async addOrUpdateRfidCard(): Promise<void> {
        if (!this.customerId) {
            this.rfidCardService.isRfidCardAlreadyAssigned(this.rfidCardResult.uid).pipe().subscribe(alreadyAssigned => {
                // Card can be locally assigned (at user's creation)
                const customerCards = this.rfidCards.map(r => r.cardNumber);
                if (alreadyAssigned) {
                    this.alreadyAssigned = true;

                } else if (customerCards.find(value => value === this.rfidCardResult.cardNumber)) {
                    this.selfAssigned = true;

                } else {
                    this.rfidCards.push(this.rfidCardResult);
                    this.activeModal.close(this.rfidCards);
                }
            });

        } else {
            this.rfidCardService.assignRfidCardToCustomer(this.customerId, this.rfidCardResult).pipe().subscribe(rfiCard => {
                this.rfidCards.push(rfiCard);
                this.activeModal.close(this.rfidCards);
                this.notificationsService.success({ message: 'cards.notifications.assignSuccess' });
            });
        }
    }

    private clearInput(): Array<SearchCustomerDto> {
        this.rfidCardResult = null;
        return [];
    }

    printFormattedCardIdentifier(rfidCard: CardDto): string {
        return this.translateService.instant('users.card.formattedIdentifier', {cardNumber: rfidCard.cardNumber, uid: rfidCard.uid});
    }
}
